import React from "react";
const autobind = require("class-autobind").default;
// import {FormGroup} from "../group/index";
// import {Button} from "../../button/index";
import DayPicker from "react-day-picker";
import moment from "moment-timezone";
import { FORMATS } from "@lib/common";
import styled from "../../../styled";
import { Input } from "../input";
const ClickOutComponent = require("react-onclickout");
const Wrapper = styled("div") `
  position: relative;
  .dropdown {
    z-index: 2;
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border: 1px solid ${({ theme }) => theme.input.border};
    display: ${({ active }) => active ? "block" : "none"};
  }
`;
export class DatePicker extends React.Component {
    open = false;
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            dropdown: false,
        };
    }
    onSelect = (date) => {
        const { timezone, onSelect } = this.props;
        const parsed = moment.tz(date, timezone);
        onSelect({
            moment: parsed,
            millis: parsed.valueOf(),
            date: parsed.format(FORMATS.moment.date),
            raw: date,
        });
    };
    render() {
        const { date, timezone, displayFormat, className } = this.props;
        const { dropdown } = this.state;
        return (React.createElement(Wrapper, { active: dropdown, className: className },
            React.createElement(ClickOutComponent, { onClickOut: () => {
                    this.setState({ dropdown: false });
                } },
                React.createElement(Input, { className: "no-round", readOnly: true, value: moment.tz(date, timezone).format(displayFormat), onFocus: () => {
                        this.setState({ dropdown: true });
                    } }),
                React.createElement("div", { className: "dropdown" },
                    React.createElement(DayPicker, { selectedDays: date, onDayClick: this.onSelect })))));
    }
}
//# sourceMappingURL=index.js.map